import { useEffect, useRef, useState } from 'react';

export const WaterRipple = ({ children, className = '' }) => {
  const containerRef = useRef(null);
  const canvasRef = useRef(null);
  const [ripples, setRipples] = useState([]);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return;

    const ctx = canvas.getContext('2d');
    const rect = container.getBoundingClientRect();
    
    canvas.width = rect.width;
    canvas.height = rect.height;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      setRipples(prevRipples => {
        const updatedRipples = prevRipples
          .map(ripple => ({
            ...ripple,
            radius: ripple.radius + 2,
            opacity: ripple.opacity - 0.008,
          }))
          .filter(ripple => ripple.opacity > 0);

        updatedRipples.forEach(ripple => {
          ctx.beginPath();
          ctx.arc(ripple.x, ripple.y, ripple.radius, 0, Math.PI * 2);
          ctx.strokeStyle = `rgba(26, 77, 46, ${ripple.opacity})`;
          ctx.lineWidth = 2;
          ctx.stroke();
          
          // Second ring
          if (ripple.radius > 20) {
            ctx.beginPath();
            ctx.arc(ripple.x, ripple.y, ripple.radius - 20, 0, Math.PI * 2);
            ctx.strokeStyle = `rgba(26, 77, 46, ${ripple.opacity * 0.5})`;
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        });

        return updatedRipples;
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  const handleClick = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRipples(prev => [...prev, { x, y, radius: 0, opacity: 0.6 }]);
  };

  const handleMouseMove = (e) => {
    if (Math.random() > 0.95) {
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      setRipples(prev => [...prev, { x, y, radius: 0, opacity: 0.3 }]);
    }
  };

  return (
    <div 
      ref={containerRef} 
      className={`relative ${className}`}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
    >
      <canvas
        ref={canvasRef}
        className="absolute inset-0 pointer-events-none z-10"
        style={{ mixBlendMode: 'multiply' }}
      />
      {children}
    </div>
  );
};
